import { type RouteExportParams } from '~/types/router.type';

export const routeParams: RouteExportParams = {
  permissions: ['org_unit.'],
  vestigasSupportAccess: true,
};
